const firstNames = ['John', 'Jane', 'Michael', 'Sarah', 'David', 'Emily', 'Robert', 'Lisa', 'James', 'Maria', 'William', 'Jennifer', 'Richard', 'Patricia', 'Charles', 'Linda', 'Thomas', 'Barbara', 'Christopher', 'Susan'];
const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson', 'Thomas', 'Taylor', 'Moore', 'Jackson', 'Martin'];

const companyNames = ['Tech Solutions Inc', 'Global Dynamics LLC', 'Innovation Partners', 'Digital Ventures Corp', 'Strategic Systems Ltd', 'Advanced Technologies', 'Premier Services Group', 'Elite Consulting', 'Nexus Enterprises', 'Quantum Solutions', 'Apex Industries', 'Pinnacle Corp', 'Synergy Partners', 'Vertex Systems', 'Catalyst Group', 'Momentum LLC', 'Fusion Technologies', 'Horizon Enterprises', 'Summit Solutions', 'Vanguard Corp'];

const productPrefixes = ['Cloud', 'Smart', 'Pro', 'Enterprise', 'Digital', 'Advanced', 'Premium', 'Elite', 'Ultimate', 'Next-Gen', 'AI-Powered', 'Intelligent', 'Automated', 'Unified', 'Integrated'];
const productTypes = ['Analytics', 'Dashboard', 'Platform', 'Suite', 'Hub', 'Workspace', 'Manager', 'Assistant', 'Engine', 'Portal', 'Connect', 'Insights', 'Monitor', 'Optimizer', 'Tracker'];

const featureTypes = ['Management', 'Analytics', 'Integration', 'Support', 'Tracking', 'Monitoring', 'Reporting', 'Automation', 'Security', 'Backup'];
const featureSubjects = ['Domain Name', 'Email Messages', 'Email Aliases', 'User Accounts', 'API Keys', 'SSL Certificates', 'DNS Records', 'Billing', 'Notifications', 'Audit Logs'];
const featureTargets = ['for Enterprises', 'for Investors', 'for Teams', 'for Developers', 'for Agencies', ''];
const specialFeatures = ['Priority Support', 'SSO Integration', 'Multi-Factor Authentication', 'Custom Branding', 'White Label', 'Advanced Permissions', 'Bulk Operations', 'API Access', 'Webhook Support', 'Real-time Sync'];

export const generatePersonName = () => {
  const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
  const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
  return `${firstName} ${lastName}`;
};

export const generateCompanyName = () => {
  return companyNames[Math.floor(Math.random() * companyNames.length)];
};

export const generateProductName = () => {
  const prefix = productPrefixes[Math.floor(Math.random() * productPrefixes.length)];
  const type = productTypes[Math.floor(Math.random() * productTypes.length)];
  return `${prefix} ${type}`;
};

export const generateProductFeatureName = () => {
  // 30% chance for special feature, 70% chance for composed feature
  if (Math.random() < 0.3) {
    return specialFeatures[Math.floor(Math.random() * specialFeatures.length)];
  }
  
  const subject = featureSubjects[Math.floor(Math.random() * featureSubjects.length)];
  const type = featureTypes[Math.floor(Math.random() * featureTypes.length)];
  const target = featureTargets[Math.floor(Math.random() * featureTargets.length)];
  
  return `${subject} ${type} ${target}`.trim();
};